import FiltersPanelSection from './FiltersPanelSection'

export default FiltersPanelSection
